import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { PATH_HOME } from "src/routes/paths";
import { Redirect } from "react-router-dom";
import LoadingScreen from "src/components/LoadingScreen";
import useSessionAuth from "src/hooks/useSessionAuth";
import { getUser } from "src/redux/slices/user";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import axios from "src/utils/axios";
import { resetAllData } from "src/redux/slices/product";
import { cleanSessionSuccess } from "src/redux/slices/session";
// ----------------------------------------------------------------------

NoAuthorizedSessionProtect.propTypes = {
  children: PropTypes.node,
};

function NoAuthorizedSessionProtect({ children }) {
  const { isLoading, isSessionAuthenticated, session } = useSessionAuth();
  const [isSessionClose, setIsSessionClose] = useState(false);
  const [loadingGet, setLoadingGet] = useState(true);
  const { pathname } = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetAllData());
    dispatch(cleanSessionSuccess());
  }, []);

  useEffect(() => {
    const user = window.localStorage.getItem("userId");
    if (user && user !== "00000000-0000-0000-0000-000000000000") {
      dispatch(getUser(window.localStorage.getItem("userId")));
    }
  }, []);

  useEffect(() => {
    // Modo "solo carta QR" (mesa con JustCartaQr=true): el backend devuelve
    // una session sintética sin `id` real — sirve para leer la carta pero
    // no representa una sesión persistida. NO hay endpoint `actual/session`
    // que consultar (no existe fila) y el redirect a "start" no aplica
    // porque siempre es cliente anónimo. Solo hidratamos el user para
    // pintar branding y salimos.
    if (session?.isOnlyQr) {
      if (session.idRestaurante) dispatch(getUser(session.idRestaurante));
      setLoadingGet(false);
      return;
    }

    if (session && session.id && session.id !== "00000000-0000-0000-0000-000000000000") {
      getSession();
      dispatch(getUser(session.idRestaurante));
    } else {
      setLoadingGet(false);
    }
  }, [session]);

  const getSession = () => {
    setLoadingGet(true);
    const tokenStorage = window.localStorage.getItem("accessToken");

    axios
      .get(`data/actual/session/${session.id}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${tokenStorage}`,
        },
      })
      .then((response) => {
        if (response.data.session === null) {
          setIsSessionClose(true);
          return;
        }

        if (response.data.session.isClosed || !response.data.session.isActive) {
          setIsSessionClose(true);
          return;
        }

        setIsSessionClose(false);
      })
      .catch((error) => {
        setIsSessionClose(true);
      })
      .finally(() => {
        setLoadingGet(false);
      });
  };

  if (isLoading || loadingGet) {
    return <LoadingScreen />;
  }

  const isSessionTarget = pathname.includes("start");

  if (isSessionAuthenticated && !isSessionClose && isSessionTarget) {
    return <Redirect to={PATH_HOME.root} />;
  }

  return <>{children}</>;
}

export default NoAuthorizedSessionProtect;
